import { Query } from '@apollo/client/react/components';
import React from 'react';

import { Messages } from '../../../../../gen-src/Localize';
import { FlowQuery, FlowQueryVariables, FlowDocument } from '../../../../../gen-src/queries';
import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '../../../data-catalog-shared';
import { RenderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type FlowQueryWrapperProps = {
  readonly flowVizportalUrlId: string;
  readonly children: (result: Unpacked<FlowQuery['flows']>) => React.ReactNode;
};

export class FlowQueryWrapper extends React.Component<FlowQueryWrapperProps> {

  public override render(): React.ReactNode {
    return (
      <Query<FlowQuery, FlowQueryVariables>
        query={FlowDocument}
        variables={{ flowVizportalUrlId: this.props.flowVizportalUrlId }}
      >
        {result => <RenderQueryResult result={result} renderers={{
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderFlowData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderFlowData),
          renderError: renderError,
        }} />}
      </Query>
    );
  }

  private readonly renderFlowData = (data: FlowQuery): React.ReactNode => {
    const flow = data.flows ? data.flows[0] : null;
    if (flow) {
      return this.props.children(flow);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }
}
